import * as React from 'react';
import { cn } from '@/lib/utils';

const SkillCardWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-skill-card', 'grid grid-cols-[repeat(auto-fill,minmax(min(100%,300px),1fr))] gap-6', className)}
    {...props}
  />
));
SkillCardWrapper.displayName = 'SkillCardWrapper';

const SkillCard = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-skill-card', 'flex max-w-full flex-col justify-between gap-3 rounded-lg border border-solid border-neutral-lightest p-6', className)}
    {...props}
  />
));
SkillCard.displayName = 'SkillCard';

const SkillCardLevel = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-skill-card-level', 'grow rounded-xl bg-[#fafafa] p-2', className)}
    {...props}
  />
));
SkillCardLevel.displayName = 'SkillCardLevel';

export { SkillCardWrapper, SkillCard, SkillCardLevel };
